module.exports = __webpack_public_path__ + "img/LemonCustard.3832ffa4.webp";